<template>
  <div id="Home_Receipt">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="search-dollar" />
      查詢已繳款項目
      <span slot="etext">
        &emsp;Paid Records
      </span>
    </v-title>
    <hr />
    <!-- 項目Tab -->
    <ul id="myTab" class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a
          id="receipt-tab"
          class="nav-link lh-fs active"
          href="#/home/receipt"
          aria-selected="true"
        >
          查詢繳款紀錄<br />
          <v-font fontCss="spanfs" fontText="Paid Records" />
        </a>
      </li>
    </ul>
    <div class="col-12 pt-3 table-style">
      <!-- 第一層 篩選 -->
      <div class="form-group row">
        <!-- 篩選資料 -->
        <v-label class="lh-fs ml-3" for="input-query" Labbold="true" LabText="篩選資料：">
          <v-font slot="small" fontCss="spanfs" fontText="Keyword for Search" />
        </v-label>
        <div class="col-md-5">
          <input
            id="input-query"
            class="input-style"
            type="text"
            placeholder="請輸入關鍵字"
            v-model="filter"
          />
        </div>
      </div>
      <!-- 第二層 筆數 -->
      <div class="form-group row">
        <!-- 筆數 -->
        <v-label
          for="Page-select"
          class="lh-fs ml-3 mr-4"
          style="padding-right: 0.3rem !important;"
          Labbold="true"
          LabText="筆數："
        >
          <v-font slot="small" fontCss="spanfs" fontText="Items per Page" />
        </v-label>
        <div class="col-md-3">
          <v-page @RecPerPage="RecPerPage" />
        </div>
      </div>
      <hr />
      <!-- 表格資料 -->
      <template>
        <b-table
          hover
          small
          bordered
          show-empty
          stacked="md"
          empty-text="目前無資料"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <!-- 繳款編號 -->
          <template v-slot:cell(FeeOrderId)="data">
            {{ Size(data.item.FeeOrderId) }}
          </template>
          <!-- 繳款人 -->
          <template v-slot:cell(UserName)="data">
            <span class="nukWord">
              {{ data.item.UserName }}
            </span>
          </template>
          <!-- 繳款狀態 -->
          <template v-slot:cell(FeeOrderStatus)="data">
            {{ data.item.FeeOrderStatus }}
          </template>
          <!-- 金額 -->
          <template v-slot:cell(PayAmt)="data">
            {{ data.item.PayAmt + ' 元' }}
          </template>
          <!-- 繳款方式 -->
          <template v-slot:cell(PayType)="data">
            <div v-for="Type in PayTypes" :key="Type.id" :value="Type.value">
              <div v-if="data.item.PayType == Type.value">
                {{ Type.text }}
              </div>
            </div>
          </template>
        </b-table>
        <!-- 分頁 -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        />
      </template>
      <br />
    </div>
    <br />
  </div>
</template>

<script>
import { apiFeeorderQuerypaid } from '../../Api/api'
export default {
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'SerialNo',
          label: '#',
          thClass: 'table-th',
          sortDirection: 'desc',
          sortable: true
        },
        {
          key: 'PayDT',
          label: '繳費時間\nPaid Time',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'FeeOrderId',
          label: '繳款編號\nFee Order Id',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'PayOrderId',
          label: '繳費單號\nBill Number',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'ApplyDeptName',
          label: '單位\nDepartment',
          thClass: 'table-th',
          sortable: true
        },
        {
          key: 'FeeItemName',
          label: '收費項目\nFee Item Name',
          thClass: 'table-th',
          class: 'word-bold',
          sortable: true,
          variant: 'warning'
        },
        {
          key: 'FeeOrderDesc',
          label: '繳款項目事由\nDescription',
          thClass: 'table-th'
        },
        { key: 'UserName', label: '繳款人\nUserName', thClass: 'table-th' },
        {
          key: 'PayAmt',
          label: '繳款金額\nAmount',
          thClass: 'table-th',
          class: 'short',
          sortable: true,
          variant: 'warning'
        },
        {
          key: 'PayType',
          label: '繳款方式\nCategory',
          thClass: 'table-th',
          sortable: true
        }
      ],
      amount: 0,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      PayTypes: [
        { text: '未繳費', value: '0' },
        { text: '國內信用卡', value: '1' },
        { text: '國外信用卡', value: '2' },
        { text: '一卡通', value: '3' },
        { text: 'LINE Pay', value: '4' },
        { text: 'WebATM', value: '5' },
        { text: '四大超商繳款', value: '6' },
        { text: '土銀臨櫃繳款', value: '7' },
        { text: '出納組現金繳納', value: '8' },
        { text: '列印繳費單(尚未實際繳費)', value: '255' }
      ]
    }
  },
  mounted () {
    this.PostQuerypaid()
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  methods: {
    RecPerPage (SublayerPage) {
      this.perPage = SublayerPage
    },
    Size (data) {
      // 手機版字數超過12換行
      const datas = data.replace(/(.{13})/g, '$1\n')
      return datas
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostQuerypaid () {
      // 查尋已繳款 F_API 008
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      // 呼叫API
      apiFeeorderQuerypaid(NewData).then(res => {
        if (res !== undefined) {
          for (let i = 0; i < res.Data.length; i++) {
            // 遍歷GET data
            const json = res.Data[i] // 添增Count屬性
            json.SerialNo = i + 1
          }
          vm.items = res.Data
          vm.totalRows = vm.items.length // 計算頁數
        }
      })
    }
  }
}
</script>
